import { Stack } from '@mui/material'
import { settingsRowPaperClassName } from '@/components/Settings/settingsPaperGroup'
import shared from '@/components/Settings/settingsShared.module.scss'
import { THEME_OPTIONS, PR_DESTINATION_OPTIONS } from './GeneralSettingsContent/generalSettingsConstants.js'
import { GeneralSettingsPrivacySection } from './GeneralSettingsContent/GeneralSettingsPrivacySection.jsx'
import { GeneralSettingsProfileSection } from './GeneralSettingsContent/GeneralSettingsProfileSection.jsx'
import { GeneralSettingsSelectRowSection } from './GeneralSettingsContent/GeneralSettingsSelectRowSection.jsx'
import { GeneralSettingsSection } from './GeneralSettingsContent/GeneralSettingsSection.jsx'
import { ActiveSessionsTable } from './GeneralSettingsContent/ActiveSessionsTable.jsx'
import { GeneralSettingsMoreSection } from './GeneralSettingsContent/GeneralSettingsMoreSection.jsx'
import { useGeneralSettingsState } from './GeneralSettingsContent/useGeneralSettingsState.js'

export default function GeneralSettingsContent() {
  const s = useGeneralSettingsState()
  const paperSingle = settingsRowPaperClassName({ groupPosition: 'single' })
  const paperFirst = settingsRowPaperClassName({ groupPosition: 'first' })
  const paperLast = settingsRowPaperClassName({ groupPosition: 'last' })

  return (
    <Stack spacing={3} className={shared.briefingsRoot}>
      <GeneralSettingsPrivacySection paperFirst={paperFirst} paperLast={paperLast} />
      <GeneralSettingsProfileSection paperSingle={paperSingle} email={s.email} firstName={s.firstName} lastName={s.lastName} onFirstNameChange={s.setFirstName} onLastNameChange={s.setLastName} />
      <GeneralSettingsSelectRowSection title="Appearance" introKey="general-appearance" paperSingle={paperSingle} rowTitle="Theme" hideDescription ariaLabel="Theme" value={s.theme} options={THEME_OPTIONS} onChange={s.setTheme} />
      <GeneralSettingsSelectRowSection title="PR Preferences" introKey="general-pr-preferences" paperSingle={paperSingle} rowTitle="Preferred PR destination" rowDescription="Choose where PR links open across web, the desktop app and IDE." ariaLabel="Preferred PR destination" value={s.prDestination} options={PR_DESTINATION_OPTIONS} onChange={s.setPrDestination} />
      <GeneralSettingsSection title="Active Sessions" introKey="general-sessions">
        <ActiveSessionsTable />
      </GeneralSettingsSection>
      <GeneralSettingsMoreSection paperFirst={paperFirst} paperLast={paperLast} />
    </Stack>
  )
}
